export const STUDY_MANAGEMENT_FLAGS = {
    cloneStudies: {
        id: 'cloneStudies',
        value: false,
        description: 'Enables the ability to clone a study',
        owner: 'Enterprise experience team',
        name: 'Clone studies',
        disabled: true,
        extra: { section: 'Studies' },
    },
    review: {
        id: 'review',
        value: false,
        description: 'Enables the review tab under Build section for a study',
        owner: 'Enterprise experience team',
        name: 'Review',
        extra: { section: 'Studies' },
    },
    chat: {
        id: 'chat',
        value: false,
        description: 'Enables AI chat',
        owner: 'Enterprise experience team',
        name: 'Medable chat',
        disabled: true,
        extra: { section: 'Studies' },
    },
    restoreVersion: {
        id: 'restoreVersion',
        value: false,
        description: 'Enables Restoring of study version',
        owner: 'Enterprise experience team',
        name: 'Restore Version',
        disabled: true,
        extra: { section: 'Studies' },
    },
    experimentalPackages: {
        id: 'experimentalPackages',
        value: false,
        description: `When enabled, study build will use non-stable 'dev-latest' template`,
        owner: 'Enterprise experience team',
        name: 'Use latest template',
        extra: { section: 'Studies' },
    },
    studySummary: {
        id: 'studySummary',
        value: false,
        description: 'Enables Study Summary in Build section & PDS under Versions',
        owner: 'Study Test Team',
        name: 'Study Summary',
        extra: { section: 'Studies' },
    },
};
